export default __webpack_public_path__ + "static/media/kaci-baum-1.4671afa5.jpg";